module.exports = __webpack_public_path__ + "img/7.ce713fd.svg";